import useFocus from "@/lib/hooks/interactions/other/useFocus";
import { InputPropsType } from "@/lib/main";
import { CSSProperties } from "react";
import formStyle from "./formStyle.shared";

// TODO: Add validations
export default function Input({
  name,
  autoComplete,
  maxLength,
  placeholder,
  value,
  setValue,
  valueValid,
  min,
  max,
  required,
  disabled,
  inputRef,
  inputKeyDown,
  type,
  alertColor,
  fullWidth,
  icon,
}: InputPropsType) {
  const { isFocused, onFocus, onBlur } = useFocus();

  const sharedStyle = formStyle({ value, isFocused, alertColor, disabled });
  const styles: CSSProperties = {
    ...sharedStyle,
    height: "3rem",
    paddingInlineStart: icon
      ? "calc(var(--spacing-md) + var(--spacing-2xl) + var(--spacing-sm))"
      : "var(--spacing-md)",
    paddingInlineEnd:
      type === "password"
        ? "calc(var(--spacing-md) + var(--spacing-2xl) + var(--spacing-sm))"
        : "var(--spacing-md)",
    textOverflow: "ellipsis",
    width: fullWidth ? "100%" : "auto",
  };

  return (
    <input
      ref={inputRef}
      aria-invalid={!valueValid}
      autoComplete={autoComplete}
      maxLength={maxLength}
      min={min}
      max={max}
      name={name}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={inputKeyDown}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      style={styles}
      type={type}
      value={value}
    />
  );
}
